import { ConfigurationTypes } from '../../core/src/const/ConfigurationTypes';
import IAdvanceGeneralGameConfig from "../../core/src/managers/contracts/configurations/game/IAdvanceGeneralGameConfig";
import ConfigManager from "./../../core/src/managers/ConfigManager";
import IVendorClientConfigRequestData from "./../server/requests/contracts/IVendorClientConfigRequestData";

class Configs {
    public get game() {
        if (ConfigManager.hasConfig(ConfigurationTypes.GAME)) {
            return (ConfigManager.getConfig(ConfigurationTypes.GAME) as IAdvanceGeneralGameConfig<IVendorClientConfigRequestData>);
        }
    }

    public get vendorServer() {
        if (ConfigManager.hasConfig(ConfigurationTypes.VENDOR_SERVER)) {
            return ConfigManager.getConfig(ConfigurationTypes.VENDOR_SERVER);
        }
    }

    public get bet() {
        if (ConfigManager.hasConfig(ConfigurationTypes.BET)) {
            return ConfigManager.getConfig(ConfigurationTypes.BET);
        }
    }

    public get buyFeature() {
        if (ConfigManager.hasConfig(ConfigurationTypes.BUY_FEATURE)) {
            return ConfigManager.getConfig(ConfigurationTypes.BUY_FEATURE);
        }
    }

    public get symbolSpineAnimations() {
        if (ConfigManager.hasConfig(ConfigurationTypes.SYMBOL_SPINE_ANIMATIONS)) {
            return ConfigManager.getConfig(ConfigurationTypes.SYMBOL_SPINE_ANIMATIONS);
        }
    }

    public get spineAnimations() {
        if (ConfigManager.hasConfig(ConfigurationTypes.SPINE_ANIMATIONS)) {
            return ConfigManager.getConfig(ConfigurationTypes.SPINE_ANIMATIONS);
        }
    }

    public get local() {
        if (ConfigManager.hasConfig(ConfigurationTypes.LOCAL)) {
            return ConfigManager.getConfig(ConfigurationTypes.LOCAL);
        }
    }

    public get settings() {
        if (ConfigManager.hasConfig(ConfigurationTypes.SETTINGS)) {
            return ConfigManager.getConfig(ConfigurationTypes.SETTINGS);
        }
    }

    public get error() {
        if (ConfigManager.hasConfig(ConfigurationTypes.ERROR)) {
            return ConfigManager.getConfig(ConfigurationTypes.ERROR);
        }
    }

    public get reels() {
        if (ConfigManager.hasConfig(ConfigurationTypes.REEL)) {
            return ConfigManager.getConfig(ConfigurationTypes.REEL);
        }
    }

    public get components() {
        if (ConfigManager.hasConfig(ConfigurationTypes.COMPONENTS)) {
            return ConfigManager.getConfig(ConfigurationTypes.COMPONENTS);
        }
    }
}

export default new Configs();
